import type { ReactNode } from 'react';
import { useDragScroll } from '../hooks/useDragScroll';

export default function DragScrollRow({ className = '', children }: { className?: string; children: ReactNode }) {
  const drag = useDragScroll<HTMLDivElement>();
  return (
    <div
      ref={drag.ref}
      onMouseDown={drag.onMouseDown}
      onMouseMove={drag.onMouseMove}
      onMouseUp={drag.onMouseUp}
      onMouseLeave={drag.onMouseLeave}
      onClickCapture={drag.onClickCapture}
      className={`overflow-x-auto ${drag.className} ${className}`}
      style={{ scrollbarWidth: 'none' }}
    >
      {children}
    </div>
  );
}
